import React from "react";

const Howitworks = () => {
  return (
    <div className="2xl:container flex justify-center items-center md:px-[70px] px-6">
      <div className="hidden md:block">
        <img
          src={process.env.PUBLIC_URL + "/images/ourapp/howitworks.svg"}
          alt="How it works illustration"
        />
      </div>
      <div className="block md:hidden">
        <img
          src={process.env.PUBLIC_URL + "/images/ourapp/howitworksmobile.svg"}
          alt="How it works illustration"
        />
      </div>
    </div>
  );
};

export default Howitworks;
